module.exports = __webpack_public_path__ + "static/07-b4c77f6f195b5d47826e8984fd0a0f47.jpg";